import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Checkmark from "../Loaders/Checkmark";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "../Loaders/ErrorMark";
import { Typography } from "@mui/material";
import configProduction from "./../config.production";

function DataLoader() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const apiUrl = configProduction.apiUrl;
  const [error, setError] = useState(null);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [showErrorCheckMark, setShowErrorCheckMark] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ticketId = queryParams.get("ticket_id");
  const [response, setResponse] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = {
          ticket_id: ticketId,
        };
        const response = await axios.post(
          `${apiUrl}proactive_entitlement_check/`,
          [params]
        );
        console.log("resp", response);

        localStorage.setItem("customer_name", response.data.customer_name);
        localStorage.setItem("ticket_subject", response.data.ticket_subject);
        localStorage.setItem(
          "ticket_description",
          response.data.ticket_description
        );
        localStorage.setItem("contact_name", response.data.contact_name);
        localStorage.setItem("contact_email", response.data.contact_email);
        localStorage.setItem("ticket_id", ticketId);
        localStorage.setItem("org_id", response.data.org_id);
        localStorage.setItem("ticket_id", response.data.ticket_id);
        localStorage.setItem("account_id", response.data.account_id);
        //localStorage.setItem("estimatetype", response.data.data.estimate_type);

        setResponse(response);
        setShowCheckmark(true);
        setTimeout(() => {
          setShowCheckmark(false);
          const frontendURL = `${window.location.origin}/dashboard`;
          window.location.href = frontendURL;
        }, 1000);

        setLoading(false);
      } catch (error) {
        setShowErrorCheckMark(true);
        setTimeout(() => {
          navigate("/error500");
        }, 1000);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [ticketId]);

  return (
    <>
      {loading ? (
        <div
          className="circle-loader"
          style={{
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            marginTop: "15rem",
          }}
        >
          <CircularProgress
            style={{ margin: "auto", height: "6rem", width: "6rem" }}
          />
        </div>
      ) : showErrorCheckMark ? (
        <div className="error">
          <Loader />
          <Typography
            variant="h4"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "-10rem",
              color: "red",
            }}
          >
            Something went wrong!!
          </Typography>
        </div>
      ) : showCheckmark ? (
        <div className="checkmark">
          <Checkmark />
          <Typography
            variant="h4"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "-10rem",
              color: "#00b01d",
            }}
          >
            Success!!
          </Typography>
        </div>
      ) : null}{" "}
      {/* Remove the <Dashboard /> component rendering condition */}
    </>
  );
}

export default DataLoader;
